import React from "react"
import { useNavigate } from "react-router-dom"
import {
    NewLabelOutlined,
    AccountTreeOutlined,
    CardMembershipOutlined,
    AdminPanelSettingsOutlined,
    ReceiptLongOutlined,
    StorageOutlined
} from "@mui/icons-material"
import _ from "lodash"
import { SectionLayout } from "../components/index"

const NAV_SECTIONS = [
    {
        title: "Onboarding",
        items: [
            {
                name: "Create New Client",
                description: "Onboard a school or college",
                to: "new",
                icon: <NewLabelOutlined />
            }
        ]
    },
    {
        title: "Management",
        items: [
            {
                name: "Client List",
                description: "All onboarded institutions",
                to: "client_list",
                icon: <AccountTreeOutlined />
            },
            {
                name: "Platform Fee Setting",
                description: "Pricing and platform charges",
                to: "fee_setting",
                icon: <CardMembershipOutlined />
            },
            {
                name: "Billing",
                description: "Total users per institution",
                to: "billing",
                icon: <ReceiptLongOutlined />
            },
            {
                name: "Database",
                description: "Browse and download all tables",
                to: "database",
                icon: <StorageOutlined />
            }
        ]
    }
]

function isOwner() {
    try {
        const user = localStorage.getItem("current_user")
        return _.get(JSON.parse(user), "user_data.meta_data.user_type", "") === "owner"
    } catch (error) {
        return false
    }
}

export default function AdminRoot() {
    const navigate = useNavigate()
    const allowed = React.useMemo(isOwner, [])

    React.useEffect(() => {
        if (!allowed) {
            navigate("/", { replace: true })
        }
    }, [allowed, navigate])

    if (!allowed) {
        return null
    }

    return (
        <SectionLayout
            basePath="/admin"
            title="Admin Panel"
            subtitle="Platform owner"
            icon={<AdminPanelSettingsOutlined />}
            sections={NAV_SECTIONS}
            collapseStorageKey="admin_sidebar_collapsed"
        />
    )
}
